<template>
  <div v-if="params.expected_delivery_date">
    <span
      v-b-popover.hover.top="$t('myLoads.myLoadsTable.edd')"
      :class="
        compareDatesEpd(
          params.expected_delivery_date,
          setLoadStatusColor(params.load_status)
        )
      "
    >
      {{ params.expected_delivery_date | dateFormat }}
    </span>
  </div>
</template>
<script>
import dayjs from "dayjs";
import LoadStatusType from "../../Extend/LoadStatusType";

export default {
  name: "LoadDateExpectedEdd",
  props: {
    params: {
      type: Object,
    },
  },
  mixins: [LoadStatusType],
  data() {
    return {
      currentDate: null,
    };
  },
  created() {
    this.currentDate = dayjs().format("MM-DD-YYYY");
  },
  methods: {
    compareDatesEpd(loadDate, loadStatus) {
      if (loadStatus.label.toLowerCase() === "in transit") {
        const formatLoadDate = dayjs(loadDate).format("MM-DD-YYYY");
        const loadDateIsBeforeCurrentDate = dayjs(formatLoadDate).isBefore(
          this.currentDate
        );
        if (loadDateIsBeforeCurrentDate) {
          return "expired-date";
        }
        return null;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" >
.expired-date {
  color: red;
}
</style>
